import { forwardRef } from 'react';
import { ProfessionalProfile } from '~/components/CandidateOverview/components';
import { EnablePermanentJobM2M } from '~/constants/ff.posthog';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import {
  fireConfirmCandidateOverviewClicked,
  fireConfirmCandidateProfileClicked,
} from '~/posthogs/events';
import { ConfirmOrDecline } from './ConfirmOrDecline';

export const CandidateHeader = forwardRef(
  (
    {
      candidate,
      job,
      currentCounter,
      allCandidates,
      notesForTemp,
      allowNavigation,
      onDeclineConfirmed,
      onConfirmOutcome,
      onConfirmPendingChange,
      onDeclinePendingChange,
      onDeclineSuccess,
      onPaymentMissing,
      isHasBackgroundCheck,
      displayProfession,
    },
    ref,
  ) => {
    const isEnablePermanentJobM2M = useFeatureFlag(EnablePermanentJobM2M);

    return (
      <div
        ref={ref}
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          marginBottom: 20,
          marginTop: 8,
          height: 120,
        }}
      >
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingLeft: isHasBackgroundCheck ? 20 : 40,
            paddingRight: 40,
          }}
        >
          <ProfessionalProfile
            hasBackgroundCheck={isHasBackgroundCheck}
            hasWorkedWithDSO={candidate.hasWorkedWithDSO}
            hasWorkedWithOffice={candidate.hasWorkedWithOffice}
            displayProfession={displayProfession}
            job={job}
            professional={candidate}
            onTrackOverviewClick={() => {
              if (isEnablePermanentJobM2M) {
                fireConfirmCandidateOverviewClicked({
                  interviewId: job.id,
                  postingId: job.postingId,
                  professionalId: candidate.id,
                });
              } else {
                fireConfirmCandidateProfileClicked({ shiftId: job.id });
              }
            }}
          />
          <ConfirmOrDecline
            candidateId={candidate?.id}
            job={job}
            currentCounter={currentCounter}
            allCandidates={allCandidates}
            notesForTemp={notesForTemp}
            allowNavigation={allowNavigation}
            onDeclineConfirmed={onDeclineConfirmed}
            onConfirmOutcome={onConfirmOutcome}
            onConfirmPendingChange={onConfirmPendingChange}
            onDeclinePendingChange={onDeclinePendingChange}
            onDeclineSuccess={onDeclineSuccess}
            onPaymentMissing={onPaymentMissing}
          />
        </div>
      </div>
    );
  },
);
